import { z } from "zod/v4";

export const reflectionSkillSchema = z.object({
	skill: z.string(),
	self_rating: z.number().int().min(1).max(5).nullish(),
});

export const reflectionSchema = z.object({
	user_id: z.string().uuid(),
	display_name: z.string(),
	avatar_url: z.string().nullable().optional(),
	// Go nil pointers use omitempty, so these keys are often absent rather than null.
	mood: z.number().int().min(1).max(4).nullish(),
	intensity: z.number().int().min(1).max(10).nullish(),
	notes: z.string().nullable().optional(),
	skills: z.array(reflectionSkillSchema),
	logged_at: z.iso.datetime({ offset: true }),
	photo_url: z.string().nullable().optional(),
});

export const reflectionSummarySchema = z.object({
	count: z.number().int(),
	avg_mood: z.number().nullish(),
	avg_intensity: z.number().nullish(),
	top_skills: z.array(z.string()),
});

export const reflectionsResponseSchema = z.object({
	reflections: z.array(reflectionSchema),
	summary: reflectionSummarySchema,
});

export type Reflection = z.infer<typeof reflectionSchema>;
export type ReflectionSkill = z.infer<typeof reflectionSkillSchema>;
export type ReflectionSummary = z.infer<typeof reflectionSummarySchema>;
export type ReflectionsResponse = z.infer<typeof reflectionsResponseSchema>;
